<template>

    <form ref="acaocomercial-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="acaoComercialExternalHash">AcaoComercialExternalHash</label>
                        <input type="text" class="form-control" name="acaoComercialExternalHash" placeholder="AcaoComercialExternalHash" v-model="model.acaoComercialExternalHash" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="escolaId">EscolaId</label>
                        <input type="text" class="form-control" name="escolaId" placeholder="EscolaId" v-model="model.escolaId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="nomeEscola">NomeEscola</label>
                        <input type="text" class="form-control" name="nomeEscola" placeholder="NomeEscola" v-model="model.nomeEscola" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="descricao">Descricao</label>
                        <input type="text" class="form-control" name="descricao" placeholder="Descricao" v-model="model.descricao" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="statusAcaoComercialId">StatusAcaoComercialId</label>
                        <input type="text" class="form-control" name="statusAcaoComercialId" placeholder="StatusAcaoComercialId" v-model="model.statusAcaoComercialId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataInicio">DataInicio</label>
                        <input type="text" v-datepicker class="form-control" name="dataInicio" v-model="model.dataInicio" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataFim">DataFim</label>
                        <input type="text" v-datepicker class="form-control" name="dataFim" v-model="model.dataFim" required />
                    </div>


        </div>

        <button type="button" class="btn btn-outline-secondary" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "acaocomercial-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "acaocomercial-form-create",
            
            resources: {
                create: 'acaocomercial',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

